const codes = {
  accountExistsDiffCred: "auth/account-exists-with-different-credential",
  networkError: "api/network-error",
  userNotFound: "api/user-not-found",
  unassociatedItem: "api/item-unassociated",
  signInCancelled: "api/sign-in-cancelled"
};

export default codes;
